// src/pages/OpenSourceProjects.js

import React from 'react';

const OpenSourceProjects = () => {
  return (
    <div>
      <div className='main'>
        <div className="column1"></div>
        <div className="column2">
          <br />
          <br />
          <div style={{ textAlign: 'center' }}>
            <h1>Open Source Projects</h1>
          </div>
          <p>
            We are engaged in multiple projects, both open-source and commercial, to ensure the future survival of the human race. Each day is a struggle to advance laws supporting body autonomy, and this journey takes a toll on our continuous existence. That's why we need your support.
          </p>
          <p>
            If you are interested in volunteering or collaborating with us, please get in touch anytime!
          </p>
          <p>
            <a href="https://github.com/Sabrenetics" target="_blank" rel="noopener noreferrer">GitHub: Sabrenetics</a>
          </p>
          <br />
        </div>
        <div className="column3"></div>
      </div>
    </div>
  );
};

export default OpenSourceProjects;
